import React, { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';

const ShowOn: FunctionComponent<ShowOn> = ({
  children,
  mobileViewport,
  desktopViewport,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (isMobile) {
    return mobileViewport ? <>{children}</> : null;
  }

  return desktopViewport ? <>{children}</> : null;
};

interface ShowOn {
  mobileViewport: boolean;
  desktopViewport: boolean;
}

export default ShowOn;
